import {mapState} from 'vuex';

export const common = {
	
	computed:{
		...mapState({
			test:state => state.test.test,
			cashierCart:state=>state.cart.cashierCart,
			cashierCartIndex:state=>state.cart.cashierCartIndex,
			cashierMember:state=>state.member.cashierMember,
			gua:state=>state.gua.gua,
		}),
		getSelectKey(){
			return this.$route.name;
		}
	},
	methods:{
		refreshPage(page){ // 比如弹出层操作后要跳转到某个页面就这样执行
			this.$router.push({path:'/refresh',query:{path:page}});
		},
	}
}